import burgerImage1 from "../../assets/images/fille-burger.png";
import burgerImage2 from "../../assets/images/beign-bleuet.png";
import burgerImage3 from "../../assets/images/table-dessus.png";
import burgerImage4 from "../../assets/images/terrasse.png";
import chatImage1 from "../../assets/images/chatitalien.jpg";
import chatImage2 from "../../assets/images/chatarmenien.jpg";
import chatImage3 from "../../assets/images/Thewisdomofcatsisinfinitelysuperior.jpg";
import chatImage4 from "../../assets/images/chat-coussin.jpg";
import karateImage1 from "../../assets/images/jaden-smith-principal.jpg";
import karateImage2 from "../../assets/images/jcjs.jpg";
import karateImage3 from "../../assets/images/wenwen-han.jpg";
import karateImage4 from "../../assets/images/Zhenwei-wang-cheng.jpg";
import coworkingImage1 from "../../assets/images/image-coworkers.jpg";
import coworkingImage2 from "../../assets/images/img-bureauvirtuel2.png";
import coworkingImage3 from "../../assets/images/img-salledereunion.png";
import coworkingImage4 from "../../assets/images/img13.JPG";

export const burgerImages = [
  {
    src: burgerImage1,
    alt: "Image burger shop 1",
    link: "https://joslsinfo.github.io/TP3-Saintus-Jean-Oldor/",
  },
  {
    src: burgerImage2,
    alt: "Image burger shop 2",
    link: "https://joslsinfo.github.io/TP3-Saintus-Jean-Oldor/",
  },
  {
    src: burgerImage3,
    alt: "Image burger shop 3",
    link: "https://joslsinfo.github.io/TP3-Saintus-Jean-Oldor/",
  },
  {
    src: burgerImage4,
    alt: "Image burger shop 4",
    link: "https://joslsinfo.github.io/TP3-Saintus-Jean-Oldor/",
  },
];

export const refugeMimineImages = [
  {
    src: chatImage1,
    alt: "Image refuge mimine 1",
    link: "https://joslsinfo.github.io/tp1-integration-web-2/",
  },
  {
    src: chatImage2,
    alt: "Image refuge mimine 2",
    link: "https://joslsinfo.github.io/tp1-integration-web-2/",
  },
  {
    src: chatImage3,
    alt: "Image refuge mimine 3",
    link: "https://joslsinfo.github.io/tp1-integration-web-2/",
  },
  {
    src: chatImage4,
    alt: "Image refuge mimine 4",
    link: "https://joslsinfo.github.io/tp1-integration-web-2/",
  },
];

export const karateKidImages = [
  {
    src: karateImage1,
    alt: "Image karate kid 1",
    link: "https://joslsinfo.github.io/TP2-Saintus-Jean-Oldor/",
  },
  {
    src: karateImage2,
    alt: "Image karate kid 2",
    link: "https://joslsinfo.github.io/TP2-Saintus-Jean-Oldor/",
  },
  {
    src: karateImage3,
    alt: "Image karate kid 3",
    link: "https://joslsinfo.github.io/TP2-Saintus-Jean-Oldor/",
  },
  {
    src: karateImage4,
    alt: "Image karate kid 4",
    link: "https://joslsinfo.github.io/TP2-Saintus-Jean-Oldor/",
  },
];

export const josCoworkingImages = [
  {
    src: coworkingImage1,
    alt: "Image coworker 1",
    link: "https://joslsinfo.github.io/tp3-projetfinal-Saintus-Jean-Oldor/",
  },
  {
    src: coworkingImage2,
    alt: "Image coworker 2",
    link: "https://joslsinfo.github.io/tp3-projetfinal-Saintus-Jean-Oldor/",
  },
  {
    src: coworkingImage3,
    alt: "Image coworker 3",
    link: "https://joslsinfo.github.io/tp3-projetfinal-Saintus-Jean-Oldor/",
  },
  {
    src: coworkingImage4,
    alt: "Image coworker 4",
    link: "https://joslsinfo.github.io/tp3-projetfinal-Saintus-Jean-Oldor/",
  },
];
